import React, { useEffect, useState } from "react";
import { Instagram, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export default function GalleryPage() {
  const [media, setMedia] = useState([]);
  useEffect(() => {
    api.get("/media").then((r) => setMedia(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-32" data-testid="gallery-page">
      <header className="max-w-7xl mx-auto px-6 md:px-10 pt-8 pb-14">
        <div className="overline text-primary/80">Gallery</div>
        <h1 className="mt-4 font-display text-5xl md:text-7xl leading-[1.05]">The vibe, bottled.</h1>
        <p className="mt-6 text-muted-foreground text-lg max-w-2xl">
          Moments from past events — the drinks, the bars, the guests, the details.
        </p>
      </header>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5" data-testid="gallery-grid">
          {media.map((m, i) => (
            <a
              key={m.id}
              href={m.url}
              target="_blank"
              rel="noreferrer"
              className={`group relative rounded-xl overflow-hidden bg-card/40 border border-white/5 card-lift ${
                i % 5 === 0 ? "col-span-2 row-span-2 aspect-square" : "aspect-square"
              }`}
              data-testid={`gallery-item-${m.id}`}
            >
              <img
                src={m.url}
                alt={m.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="text-sm font-medium">{m.title}</div>
                {m.caption && <div className="text-xs text-white/70 mt-1">{m.caption}</div>}
              </div>
            </a>
          ))}
        </div>

        <div className="mt-20 rounded-3xl border border-white/8 p-10 md:p-14 bg-card/40" data-testid="instagram-section">
          <div className="flex items-center gap-3">
            <Instagram size={22} className="text-primary" />
            <div className="overline text-primary/80">Instagram</div>
          </div>
          <h2 className="mt-4 font-display text-3xl md:text-4xl">Follow the pours.</h2>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            Live from our recent events. Follow along at{" "}
            <a href="https://instagram.com/pinkie.up.cocktails" target="_blank" rel="noreferrer" className="text-primary">@Pinkie.Up.Cocktails</a>.
          </p>
          <div className="mt-8 grid grid-cols-3 md:grid-cols-6 gap-3">
            {media.slice(0, 6).map((m) => (
              <div key={m.id} className="aspect-square rounded-lg overflow-hidden border border-white/8">
                <img src={m.url} alt="" className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
          <a
            href="https://instagram.com/pinkie.up.cocktails"
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-5 py-2.5 border border-primary/40 text-primary hover:bg-primary hover:text-primary-foreground transition-colors text-sm"
            data-testid="instagram-follow-cta"
          >
            View on Instagram <ExternalLink size={14} />
          </a>
        </div>
      </section>
    </div>
  );
}
